module.exports = __webpack_public_path__ + "img/message-thread.c7e35df4.png";